import { useState, useEffect } from "react";

export const useFilter = ({ filterName, filterLabels, filteredValues, onChange }) => {
  const [updatedValues, setUpdatedValues] = useState({});

  useEffect(() => {
    const labels = filterLabels && Array.from(filterLabels, (v) => ({
      [v?.toLowerCase()]: filteredValues?.includes(v.toLowerCase()),
    }));

    const newState = labels && labels.length ? Object.assign(...labels) : {};
    setUpdatedValues(newState);
  }, [filteredValues, filterLabels]);

  const handleChange = (value) => {
    setUpdatedValues((updatedValues) => ({
      ...updatedValues,
      [value]: !updatedValues[value],
    }));

    onChange(
      {
        ...updatedValues,
        [value]: !updatedValues[value],
      },
      filterName
    );
  };

  const clearValues = () => {
    setUpdatedValues((prevState) => {
      let newState = {};
      Object.keys(prevState).map((key) => (newState[key] = false));
      return newState;
    });
    onChange({}, filterName);
  };

  return { handleChange, clearValues, updatedValues }
}